import { render, staticRenderFns } from "./EModalConfirmarEvento.vue?vue&type=template&id=4842d9ef"
import script from "./EModalConfirmarEvento.vue?vue&type=script&lang=js"
export * from "./EModalConfirmarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports